import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import OrderStatesTable from './OrderStatesTable';

interface IOrderStatesProps extends RouteComponentProps<{
  eshop: string;
  orderStateId: string;
}> {

}

export default class OrderStates extends React.Component<IOrderStatesProps> {

  render() {
    return (
      <div>
        <OrderStatesTable
          domain={this.props.match.params.eshop}
          orderStateId={this.props.match.params.orderStateId}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/OrderStates/index.tsx